import type {AuthSessionUser} from '@/hooks/useAuth';
import type {AfriexTokenResponse} from '@/types';
import {AfriexRoles} from '@/types/AfriexRoles';

/** The one claim every caller in this package actually reads off the token. */
export interface AdminTokenPayload {
  role?: AfriexRoles;
}

export function parseJwt(token: string): AdminTokenPayload {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload) as AdminTokenPayload;
}

export function hasAdminRole(token: string | null) {
  if (!token) {
    return false;
  }
  const tokenPayload = parseJwt(token);
  if (!tokenPayload) {
    return false;
  }

  return Boolean(tokenPayload?.role && tokenPayload.role !== AfriexRoles.USER);
}

/**
 * Saves the admin session from a verified OTP's token response and returns
 * the user `useAuth().login` takes alongside the role.
 */
export function saveAdminSession(
  tokenResponse: AfriexTokenResponse,
  adminRole: AfriexRoles,
): AuthSessionUser {
  const person = tokenResponse?.person;
  localStorage.setItem('afriex-token', tokenResponse?.tokens?.admin);
  localStorage.setItem('user-id', person?.id || '');
  localStorage.setItem('admin-role', adminRole);
  localStorage.setItem('admin-email', person?.currentEmail || '');
  localStorage.setItem('admin-firstname', person?.name?.firstName || '');
  localStorage.setItem(
    'device-token',
    person?.currentDeviceInfo?.deviceToken || '',
  );
  localStorage.removeItem('logging-in');
  return {
    email: person?.currentEmail,
    firstName: person?.name?.firstName,
  };
}
